module.exports = __webpack_public_path__ + "img/refresh.c005465f.svg";